import { render, staticRenderFns } from "./Tier0.vue?vue&type=template&id=5c9de00c"
import script from "./Tier0.vue?vue&type=script&lang=ts"
export * from "./Tier0.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c9de00c')) {
      api.createRecord('5c9de00c', component.options)
    } else {
      api.reload('5c9de00c', component.options)
    }
    module.hot.accept("./Tier0.vue?vue&type=template&id=5c9de00c", function () {
      api.rerender('5c9de00c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/upgrades/Tier0.vue"
export default component.exports